// External Imports
import { Fragment, useState } from "react";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";

// Internal Imports
import { isoDateToString } from "../../util/format-date";
import ListLabels from "../UI/ListLabels";
import Heading from "../UI/Heading";
import NoRecordsFound from "../UI/NoRecordsFound";

/** ========================================================================
 * * PaymentRefunds Component
 * This component renders a list of refunds on a payment.
 * ========================================================================== */

export default function PaymentRefunds({ refunds = [], stripeId }) {

  // Initialize States
  const [show, setShow] = useState(false);

  // Sort bookings by date
  refunds = refunds.sort(
    (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
  );

  /* =================== CLICK HANDLER =================== */
  const clickHandler = (refund) => {
    if (refund.stripeId) {
      window.open(
        `https://dashboard.stripe.com/payments/${stripeId}`,
        "_blank"
      );
    }
  };

  return (
    <div className="grid gap-2">
      <Heading
        title="Refunds"
        text="List of all refunds on this payment."
        onClick={() => setShow(!show)}
        isBackArrow={false}
      >
        {refunds.length > 0 && <div className="px-2 text-sm text-white bg-yellow-600 rounded-full">{refunds.length}</div>}
        {show ? (
          <TbChevronUp className="icon" onClick={() => setShow(false)} />
        ) : (
          <TbChevronDown className="icon" onClick={() => setShow(true)} />
        )}
      </Heading>

      {show && (
        <Fragment>
          {refunds.length > 0 ? (
            <div className="list max-h-[400px]">
              <div className="labels lg:grid-cols-6">
                <ListLabels
                  labels={[
                    "Date Created",
                    { name: "Reason", classes: "lg:col-span-2" },
                    "Refunded By",
                    "Amount",
                    "Stripe",
                  ]}
                />
              </div>
              {refunds.map((refund, idx) => (
                <div
                  key={idx}
                  onClick={() => clickHandler(refund)}
                  className="grid text-sm pill lg:grid-cols-6 text-stone-200"
                >
                  <p className="text-stone-400">
                    {isoDateToString(refund.dateCreated)}
                  </p>
                  <p className="text-stone-400 lg:col-span-2">
                    {refund.reason}
                  </p>
                  <p className="font-semibold">
                    {refund.employee?.name}
                  </p>
                  <p className="font-semibold">
                    ${refund.amount?.toFixed(2)}
                  </p>
                  <p className="font-semibold">
                    {refund.stripeId ? "View" : "N/A"}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <NoRecordsFound />
          )}
        </Fragment>
      )}
    </div>
  );
}
